import React from 'react';
import logo from '../../assets/images/logo/COLLEGELOGO.jpeg';
import './Preloader.css';

const Preloader = ({ show }) => {
  if (!show) return null;

  return (
    <div className="vj-preloader">
      <div className="vj-preloader-backdrop"></div>
      <div className="vj-preloader-content">
        <div className="vj-logo-wrapper">
          <img className="vj-loader-logo" src={logo} alt="Vidyajyoti College" />
          <div className="vj-pulse-ring"></div>
          <div className="vj-pulse-ring-outer"></div>
        </div>
        <div className="vj-loader-text">
          <h5>Vidyajyoti College</h5>
          <p>Loading Student Portal...</p>
        </div>
        <div className="vj-loader-bar">
          <div className="vj-loader-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
